export const fixedCheckboxLabels = [
  {
    flag: 'flags.LEAVE_WEEK_HOURS_MAX',
    label: 'leaveMaxBasedWeekHours',
    isInteger: false
  },
  {
    flag: 'leaveHoursBasedOnWork',
    label: 'leaveBasedOnWork',
    isInteger: true
  },
  {
    flag: 'flags.LEAVE_MIN_NEGATIVE',
    label: 'leaveBasedOnWorkNeverMin',
    isInteger: false
  },
  {
    flag: 'leaveHoursBasedOnPayed',
    label: 'leaveBasedOnPayedHours',
    isInteger: true
  },
  {
    flag: 'plbHoursBasedOnPayed',
    label: 'PLBHoursBasedOnPayedHours',
    isInteger: true
  },
  {
    flag: 'leaveHoursZeroHourContract',
    label: 'leaveHoursOnZeroContracts',
    isInteger: true
  },
  {
    flag: 'plbHoursZeroHourContract',
    label: 'PLBHoursOnZeroContracts',
    isInteger: true
  },
  {
    flag: 'flags.LEAVE_HOURS_EQUAL_PERIODS',
    label: 'leaveHoursOnZeroContractsNextYear',
    isInteger: false
  },
  {
    flag: 'flags.HOURS_PLB_NUC_NEXT_YEAR',
    label: 'PLBOnZeroContractsNextYear',
    isInteger: false
  },
  {
    flag: 'flags.FULL_MONTH_OF_LEAVE_WHEN_START_DURING_MONTH',
    label: 'leaveFullMonthOnPartial',
    isInteger: false
  }
];

export const fixedLeaveTransfer = [
  { flag: 'flags.COMP_LEAVE_FIRST', label: 'compentationLeaveFirst' },
  {
    flag: 'flags.COMP_LEAVE_EARMARKED',
    label: 'compentationLeaveEarmarked'
  },
  {
    flag: 'leaveHoursContractFloor',
    label: 'negativeLeaveBalance',
    isInteger: true
  },
  {
    flag: 'flags.LEAVE_4_PLUS_BEFORE_MIN',
    label: 'overLegalLeaveCurrentYear'
  },
  {
    flag: 'flags.AGE_HOURS_AS_LEAVE_OVER',
    label: 'ageHoursOverLegalLeave'
  }
];

export const fixedExtraHourNumberFields = [
  { name: 'extraThreshPeriod', label: 'outgoingPeriodsThreshold' },
  { name: 'extraMarginPeriod', label: 'outgoingPeriodsMargin' },
  { name: 'extraThreshPeriodLast', label: 'lastPeriodsThreshold' },
  { name: 'extraMarginPeriodLast', label: 'lastPeriodsMargin' }
];

export const deviatingReimbAttandanceFields = [
  { name: 'attendanceBaseHours', label: 'baseHours' },
  { name: 'attendanceHolidayAllowanceHours', label: 'holidayAllowanceHours46' },
  { name: 'attendanceWeekendAllowanceHours', label: 'weekendAllowanceHours46' },
  { name: 'attendanceWeekdayAllowanceHours', label: 'weekdayAllowanceHours46' },
  {
    name: 'attendanceHolidayAllowanceAmount',
    label: 'holidayAllowanceAmount45'
  },
  {
    name: 'attendanceWeekendAllowanceAmount',
    label: 'weekendAllowanceAmount45'
  },
  {
    name: 'attendanceWeekdayAllowanceAmount',
    label: 'weekdayAllowanceAmount45'
  }
];

export const deviatingReimbAttandanceFieldsOnCall = [
  { name: 'onCallBaseHours', label: 'baseHours' },
  { name: 'onCallHolidayAllowanceHours', label: 'holidayAllowanceHours44' },
  { name: 'onCallWeekendAllowanceHours', label: 'weekendAllowanceHours44' },
  { name: 'onCallWeekdayAllowanceHours', label: 'weekdayAllowanceHours44' },
  { name: 'onCallHolidayAllowanceAmount', label: 'holidayAllowanceAmount43' },
  { name: 'onCallWeekendAllowanceAmount', label: 'weekendAllowanceAmount43' },
  { name: 'onCallWeekdayAllowanceAmount', label: 'weekdayAllowanceAmount43' }
];

export const fieldCategories = [
  { key: 'payout', title: 'payoutTitle' },
  { key: 'settle', title: 'settleTitle' },
  { key: 'transfer', title: 'transferTitle' }
];

export const endOfEmploymentSettlementFields = {
  payout: [
    { name: 'payOutExtraHoursDhtId', label: 'extraHours' },
    { name: 'payOutLeaveHoursDhtId', label: 'leaveHours' },
    { name: 'payOutPlbHoursDhtId', label: 'plbHours' },
    { name: 'payOutBalanceHoursDhtId', label: 'balanceHours' }
  ],
  settle: [
    { name: 'settleExtraHoursDhtId', label: 'extraHours' },
    { name: 'settleLeaveHoursDhtId', label: 'leaveHours' },
    { name: 'settlePlbHoursDhtId', label: 'plbHours' },
    { name: 'settleBalanceHoursDhtId', label: 'balanceHours' }
  ],
  transfer: [
    { name: 'transferExtraHoursDhtId', label: 'extraHours' },
    { name: 'transferLeaveHoursDhtId', label: 'leaveHours' },
    { name: 'transferPlbHoursDhtId', label: 'plbHours' },
    { name: 'transferBalanceHoursDhtId', label: 'balanceHours' }
  ]
};
